import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconEmail from './nav-icon-email.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconEmail {...validProps} />;
}
SvgComponent.iconName = 'navIconEmail';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconEmailIcon = svgIconWrapper(SvgComponent);
